export const AuthStatus = {
    LOADING: 'loading',
    LOGOUT: 'logout',
    AUTHENTICATED: 'authenticated',
    AUTHENTICATED_LOGINLESS: 'authenticated_loginless',
    UNAUTHENTICATED: 'unauthenticated',
} as const;

export type AuthStatus = (typeof AuthStatus)[keyof typeof AuthStatus];

export interface AuthUser {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
}

export interface LoginFeedback {
    success: boolean;
    message: string;
}
